import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_1845_970)" }, [
      _createElementVNode("path", {
        d: "M1.34452 9.15431H1.07628C0.927361 9.15351 0.806013 9.27362 0.80542 9.42255V9.69289H2.42167V9.42255C2.42107 9.27465 2.30133 9.1549 2.15343 9.15431H1.88309V6.99896H12.9233C13.1373 6.99692 13.1957 6.89187 13.1942 6.73066V3.49877V0.266286C13.1936 0.117365 13.0722 -0.00280352 12.9233 -0.00194859H1.61486C1.61486 -0.00194859 1.34505 -0.00194882 1.34452 0.266286C1.34452 3.22897 1.34452 6.19164 1.34452 9.15431ZM7.53864 0.536602H12.6551V3.23053H7.53864V0.536602ZM1.88309 3.76912H6.99954V6.46041H1.88309V3.76912ZM0.80542 10.2314V13.1936C0.80542 13.6365 1.17196 14.0004 1.61486 14.0004C2.05775 14.0004 2.42167 13.6365 2.42167 13.1936V10.2314H0.80542Z",
        fill: "#FFE400"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_1845_970" }, [
        _createElementVNode("rect", {
          width: "14",
          height: "14",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}